import { motion } from "framer-motion";
import type { ReactNode } from "react";

/**
 * Reveal — scroll-triggered entrance.
 *
 * Timings are intentionally aligned with the rest of the system so a tile
 * that "lands" can be hovered immediately without timing collision:
 *   - Reveal in:        520 ms
 *   - PageTransition:   380 ms
 *   - tile-fx hover:    380 ms transform / 360 ms corner reveal
 *   - Stagger step:     60 ms (use REVEAL_STEP * index)
 * All share the same easing: cubic-bezier(0.16, 1, 0.3, 1).
 */
export const REVEAL_STEP = 0.06;
const REVEAL_EASE = [0.16, 1, 0.3, 1] as const;
const REVEAL_DURATION = 0.52;

export function Reveal({
  children,
  delay = 0,
  className,
  y = 20,
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
  y?: number;
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: REVEAL_DURATION, ease: REVEAL_EASE, delay }}
    >
      {children}
    </motion.div>
  );
}
